module.exports = __webpack_public_path__ + "img/gfgcgzh.8b61a1c1.png";